import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface RetailerEntityParams {
  id: number | string;
  name: string;
  state: string;
  city: string;
  zip: string;
}
export class RetailerEntity extends BaseEntityClass {
  id: number | string;
  name: string;
  state: string;
  city: string;
  zip: string;
  constructor(params: RetailerEntityParams) {
    super();
    this.type = "retailer";
    this.entity_version = 2;
    this.id = params.id;
    this.name = params.name;
    this.state = params.state;
    this.city = params.city;
    this.zip = params.zip;
  }

  static fromRetailer(retailer): RetailerEntity {
    const params = _.pick(retailer, ["id", "name", "state", "city", "zip"]);
    return new RetailerEntity(params);
  }
}
